import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BellStateTrueNotiFalseIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BellStateTrueNotiFalseIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M8.9081 19.6822C8.48146 19.6822 8.25647 20.1691 8.51488 20.5073C9.19771 21.4011 10.4239 22 11.8418 22C13.2598 22 14.4859 21.4011 15.1687 20.5073C15.4271 20.1691 15.2021 19.6822 14.7754 19.6822H8.9081Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.18 15.9097L19.5147 8.06899C18.7675 4.55304 15.6067 2 11.9998 2C8.3928 2 5.23258 4.55304 4.48538 8.06899L2.82005 15.9097C2.67672 16.585 2.84468 17.2799 3.28108 17.8159C3.71699 18.3518 4.36421 18.66 5.05673 18.66H18.9433C19.6358 18.66 20.283 18.3518 20.7189 17.8159C21.1553 17.2799 21.3233 16.585 21.18 15.9097Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BellStateTrueNotiFalseIcon;
